export default __webpack_public_path__ + "0af5c667933a54ee3685ab1aa1803bc0.png";